import VueRouter from 'vue-router';
import AbstractFilter from '../AbstractFilter';
import SelectFieldComponent from '@/components/forms/fields/common/SelectField.vue';
import Option from '@/zenky/forms/interfaces/FormFieldOption';
import Order from '@/zenky/interfaces/orders/Order';
import DeliveryMethod from '@/zenky/interfaces/orders/DeliveryMethod';

export default class DeliveryMethodFilter extends AbstractFilter {
  readonly name = 'delivery_method';
  readonly label: string = 'Доставка';
  async init() { }; // eslint-disable-line no-empty-function
  readonly component = SelectFieldComponent;
  get componentProps() {
    // SelectFieldComponent['values']
    const values: Array<Option & { value: Order['delivery_method']['id'] }> = [
      { label: 'Курьер', value: DeliveryMethod.DELIVERY },
      { label: 'Самовывоз', value: DeliveryMethod.PICKUP },
    ];
    return {
      values,
      placeholder: this.label,
      allowEmpty: true,
    };
  }
  valueFromQuery(query: VueRouter['currentRoute']['query']): string | null {
    return query[this.name] === undefined ? null : query[this.name] as string;
  }
  queryArgFromValue(value: ReturnType<this['valueFromQuery']>) {
    return value;
  }
}
